const MAX_CONCURRENT_REQUESTS = 1;
let requestQueue = [];
let activeRequests = 0;

const processQueue = () => {
  if (activeRequests < MAX_CONCURRENT_REQUESTS && requestQueue.length > 0) {
    const { fn, resolve, reject } = requestQueue.shift();
    activeRequests++;
    fn()
      .then(resolve)
      .catch(reject)
      .finally(() => {
        activeRequests--;
        processQueue(); 
      });
  }
};

export const enqueueRequest = (fn) => {
  console.log(fn,"fn")
  return new Promise((resolve, reject) => {
    requestQueue.push({ fn, resolve, reject });
    processQueue();
  });
};
